//FESD
import './fesd/fesd'
//全域變數
import './includes/_global'
//轉場
import './includes/_cgpagechange'
//animate
import 'animate.css/animate.min.css'
//Swiper CSS
import 'swiper/css/swiper.min.css'
import 'jquery.scrollbar/sass/jquery.scrollbar.scss'

//共用 sass
import '../sass/common/style.sass'

import { methods } from './includes/_methods'

import Blazy from 'blazy'

// header
import { header } from './includes/_header'
// button
import { button } from './includes/_button'

$(function () {

  if (fesdDB.is.isOs4 === 'isMacOS') {
    $('html').addClass('isMac')
  }
  //除Mac系統 & IE瀏覽器外套用卷軸樣式
  if (fesdDB.is.isOs4 !== 'isMacOS' && fesdDB.is.isBrowser4 !== 'isIE') {
    $('html').addClass('scrollbarStyle')
  }

  methods.appleDebug()
  methods.fixMobile100vh()

  header.all();
  button.active();
  window._common.bLazy = new Blazy({
    offset: 100,
  });
  $('[data-anchor4]').anchor4();
  $('[data-ajax4]').ajax4();
  $('[data-aost]').aost4();
  $('[video-id]').video4();

  _common.menuEvent.all();
  _common.searchEvent.all();
})
